// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class LocationValidAddressModel {
    static getAttributeTypeMap() {
        return LocationValidAddressModel.attributeTypeMap;
    }
}
LocationValidAddressModel.discriminator = undefined;
LocationValidAddressModel.additionalProperties = false;
LocationValidAddressModel.attributeTypeMap = [
    {
        "name": "line1",
        "baseName": "line1",
        "type": "string"
    },
    {
        "name": "line2",
        "baseName": "line2",
        "type": "string"
    },
    {
        "name": "city",
        "baseName": "city",
        "type": "string"
    },
    {
        "name": "state",
        "baseName": "state",
        "type": "string"
    },
    {
        "name": "postalCode",
        "baseName": "postalCode",
        "type": "string"
    },
    {
        "name": "dpv",
        "baseName": "dpv",
        "type": "Dpv"
    },
    {
        "name": "dpvDescription",
        "baseName": "dpvDescription",
        "type": "string"
    },
    {
        "name": "corrections",
        "baseName": "corrections",
        "type": ""
    },
];
//# sourceMappingURL=locationValidAddressModel.js.map